import { StackApiContext } from "@comet/admin";
import { ArrowBack } from "@mui/icons-material";
import { Typography } from "@mui/material";
import { type FC, type PropsWithChildren, useContext } from "react";
import { FormattedMessage } from "react-intl";

import { BackButton, DetailPageHeaderWrapper } from "./DetailPageHeader.sc";

export const DetailPageHeader: FC<PropsWithChildren> = ({ children }) => {
    const stackApi = useContext(StackApiContext);

    return (
        <DetailPageHeaderWrapper size={12}>
            <BackButton variant="text" color="primary" startIcon={<ArrowBack />} onClick={() => stackApi?.goBack()}>
                <Typography variant="body1">
                    <FormattedMessage id="reviermanager.button.goBack" defaultMessage="Zurück" />
                </Typography>
            </BackButton>
            {children}
        </DetailPageHeaderWrapper>
    );
};
